module.exports = __webpack_public_path__ + "static/media/logo.ccf5003c.svg";